module.exports = __webpack_public_path__ + "static/img/053 2.51cd46ce.jpg";